const PRODUCTION_API_URL =
  process.env.REACT_APP_API_URL ||
  'https://ioniangyms-mu6nj.ondigitalocean.app/api/v1';

export const API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080/api/v1'
    : PRODUCTION_API_URL;
